import { motion } from "framer-motion";
import { Stamp } from "lucide-react";
import { toast } from "sonner";
import { useCourtyard } from "@/context/CourtyardContext";
import { scrollToId } from "@/lib/event";

export default function AcceptFarmaan() {
  const { style, updateStyle } = useCourtyard();
  const on = !!style.rules_accepted;
  const accept = () => {
    updateStyle({ rules_accepted: true });
    toast.success("Mohar lag gayi! Apne pass pe dekho.", { action: { label: "See my pass", onClick: () => scrollToId("my-pass") } });
  };
  return (
    <div className="pop on-dark mt-12 flex flex-col items-center gap-5 bg-[var(--navy)] px-6 py-8 text-center text-[var(--cream)] sm:flex-row sm:justify-between sm:px-10 sm:text-left" data-testid="farmaan-accept-panel">
      <div aria-live="polite">
        <p className="font-poster text-3xl leading-none sm:text-4xl">{on ? "Mohar lag gayi. Ab mehfil mein milte hain!" : "Usool padh liye? Toh mohar laga do."}</p>
        <p className="font-serif-i mt-2 text-xl text-[#F3EAD8]">{on ? "Apne pass pe “Usool manzoor!” dekho." : "Totally optional. Your pass just gets a shiny stamp."}</p>
      </div>
      {on ? (
        <div className="flex flex-col items-center gap-1 sm:items-end">
          <button type="button" className="btn-primary" onClick={() => scrollToId("my-pass")} data-testid="farmaan-see-pass-button">See my pass</button>
          <button type="button" className="min-h-[44px] px-2 text-sm font-bold underline decoration-[var(--yellow)] decoration-2 underline-offset-4" onClick={() => updateStyle({ rules_accepted: false })} data-testid="farmaan-undo-button">
            Undo stamp
          </button>
        </div>
      ) : (
        <motion.button type="button" whileTap={{ scale: 0.9, rotate: -4 }} className="btn-primary shrink-0 text-lg" onClick={accept} data-testid="farmaan-accept-button">
          <Stamp className="h-5 w-5" aria-hidden="true" /> Usool manzoor!
        </motion.button>
      )}
    </div>
  );
}
